import { color } from "./color";
import { breakpoints, mq } from "./layout";

export const DefaultTheme = {
	color,
	breakpoints,
	mq,
};
